import { connect } from "react-redux";
import { cePromptChangeInterface } from "@js/actions/studio/campaign_content_section/modal_prompt_change_interface.js";
import { ContentBackgroundSaveSection } from "./content_background_save_section.jsx";

const StudioCampaignContentTopBar = (props) => {
  return (
    <div className="clearfix" style={{ minHeight: "50px" }}>
      {//Only render this if we're using the v2 editor
      !props.use_v1_editor && <ContentBackgroundSaveSection />}

      <div
        style={{
          marginTop: "5px",
          marginBottom: "25px",
          display: "inline-block",
        }}
      >
        {props.offer_v1_editor && (
          <a
            onClick={(e) => {
              e.preventDefault();
              props.dispatch(cePromptChangeInterface());
            }}
            href="#"
            className={`button pull-right ${
              props.use_v1_editor ? "" : "dangerous-button"
            }`}
          >
            {props.use_v1_editor
              ? t("phrases.react_content.interface_selector.upgrade")
              : t("phrases.react_content.interface_selector.downgrade")}
          </a>
        )}
      </div>

      {props.use_v1_editor_warning && (
        <p
          className="alert"
          dangerouslySetInnerHTML={{ __html: props.use_v1_editor_warning }}
        />
      )}
    </div>
  );
};

export default connect()(StudioCampaignContentTopBar);
